import styled from 'styled-components';
import { css } from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';
import { RADIUS } from '~/common/layout-propertis/radius';
import { GRID } from '~/common/layout-propertis/grid';
import { Z_INDEX } from '~/common/constants/z-index';

interface IStyOverlay {
  readonly isClosing: boolean;
}

export const StyOverlay = styled.div<IStyOverlay>`
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${Z_INDEX.MODAL};
  animation: ${({ isClosing }) =>
    !isClosing ? 'fadeinModal 400ms' : 'fadeoutModal 400ms'};

  @keyframes fadeinModal {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeoutModal {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

interface IStyModalContainer {
  readonly width: string;
  readonly height: string;
  readonly isClosing: boolean;
  readonly fullheight: boolean;
}

export const StyModalContainer = styled.div<IStyModalContainer>`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: ${({ width }) => width};
  height: ${({ height }) => height || 'fit-content'};
  transition: 200ms;
  background: ${({ theme }) => theme.neutral[900]};
  border-radius: ${RADIUS._20};
  border-width: 1px;
  box-shadow: 0px 16px 32px -12px rgba(14, 18, 27, 0.1);

  @media ${GRID._XS} {
    position: absolute;
    width: 100%;
    top: 0;
    ${({ fullheight }) =>
      !fullheight &&
      css`
        max-height: 90%;
      `}

    border-radius: ${RADIUS._20} ${RADIUS._20} 0 0px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    // @todo - confirmar se não vai impactar o iphone
    /* min-height: 350px !important; */
  }
`;

export const StyHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${SPACING._16};
  color: ${({ theme }) => theme.neutral[400]};

  & > span {
    font-size: 20px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media ${GRID._XS} {
    height: fit-content;
  }
`;

interface IStyModalContent {
  readonly justifyContent: string;
}

export const StyModalContent = styled.div<IStyModalContent>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent || 'center'};
  width: 100%;
  height: 100%;
  overflow-y: auto;
  gap: ${SPACING._16};
  padding: ${SPACING._16};
  color: ${({ theme }) => theme.neutral[400]};
`;

export const StyCloseContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: start;
  height: 100%;
  gap: ${SPACING._14};
`;

export const StyCloseButton = styled.div`
  transition: 200ms;
  &:hover {
    background-color: ${({ theme }) => theme.neutral[800]};
    border-radius: ${RADIUS._4};
  }

  svg {
    color: ${({ theme }) => theme.neutral[400]};

    &:hover {
      color: ${({ theme }) => theme.neutral[300]};
    }
  }
`;

export const StySeparator = styled.hr`
  width: 100%;
  height: 1px;
  border: none;
  background: ${({ theme }) => theme.neutral[700]};
`;

export const StyFooterContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: ${SPACING._16};
  padding: ${SPACING._16};
`;

export const StyHeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${SPACING._16};
  align-items: center;
`;

export const StyHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._4};
`;

export const StyIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border: 1px solid ${({ theme }) => theme.neutral[700]};
  border-radius: ${RADIUS._999};

  svg {
    color: ${({ theme }) => theme.neutral[400]};
  }
`;
